/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Value } from './Value.js';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value.js';

/**
 * 
 * @export
 * @interface CreateCustomerRequestEntry
 */
export interface CreateCustomerRequestEntry {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestEntry
     */
    field?: string;
    /**
     * 
     * @type {Value}
     * @memberof CreateCustomerRequestEntry
     */
    value?: Value;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateCustomerRequestEntry
     */
    properties?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequestEntry
     */
    source?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateCustomerRequestEntry
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the CreateCustomerRequestEntry interface.
 */
export function instanceOfCreateCustomerRequestEntry(value: object): boolean {
    return true;
}

export function CreateCustomerRequestEntryFromJSON(json: any): CreateCustomerRequestEntry {
    return CreateCustomerRequestEntryFromJSONTyped(json, false);
}

export function CreateCustomerRequestEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCustomerRequestEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'value': json['value'] == null ? undefined : ValueFromJSON(json['value']),
        'properties': json['properties'] == null ? undefined : json['properties'],
        'source': json['source'] == null ? undefined : json['source'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function CreateCustomerRequestEntryToJSON(value?: CreateCustomerRequestEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'field': value['field'],
        'value': ValueToJSON(value['value']),
        'properties': value['properties'],
        'source': value['source'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated'] as any).toISOString()),
    };
}

